// extracted by mini-css-extract-plugin
module.exports = {"root":"LineClamp_root__OQ_mQ","btn":"LineClamp_btn__ia5Jx"};